export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-nl_dt@3x.4ec77dfc.jpg";